import { Env, env } from 'core/config';

export const supportLink = 'https://support.joinpopp.com/';

const workflowBuilderLinkByEnv: Record<Env, string> = {
  [Env.dev]: 'https://develop.app.joinpopp.com/workflows',
  [Env.staging]: 'https://staging.app.joinpopp.com/workflows',
  [Env.prod]: 'https://app.joinpopp.com/workflows'
};

export const workflowBuilderLink = workflowBuilderLinkByEnv[env.STAGE];

const developerPortalLinkByEnv: Record<Env, string> = {
  [Env.dev]: 'https://develop.app.joinpopp.com/developer',
  [Env.staging]: 'https://staging.app.joinpopp.com/developer',
  [Env.prod]: 'https://app.joinpopp.com/developer'
};

export const developerPortalLink = developerPortalLinkByEnv[env.STAGE];
